import { Component, OnInit } from '@angular/core';
import { ClientService } from 'src/app/service/client-configuration/client.service';
import { Token } from 'src/app/manager/token';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { NotificationService } from 'src/app/service/notification.service';
import { dropDownFields } from 'src/app/manager/dropdown-feilds';
import { ConcluderInboxMappingService } from 'src/app/concluder-inbox-mapping.service';
// import { isArray } from 'rxjs';
// import { flatten } from '@angular/core/src/render3/util';

@Component({
  selector: 'app-supervisor-inbox-mapping',
  templateUrl: './supervisor-inbox-mapping.component.html',
  styleUrls: ['./supervisor-inbox-mapping.component.scss'],
  providers: [dropDownFields]
})
export class SupervisorInboxMappingComponent implements OnInit {
  ClientId = null;
  productivityForm: FormGroup;
  treeData = [];
  token: Token;
  userData;
  clientList = [];
  httpStatus = false;
  startDate;
  endDate;
  clientObj = null;
  ResponseHelper: ResponseHelper;
  maxDate = new Date();
  fieldSetting = {
    singleSelection: false,
    idField: 'Employee_Id',
    textField: 'Full_Name',
    itemsShowLimit: 2,
    closeDropDownOnSelection: true,
    allowSearchFilter: true
  };
  activeUserList = []
  userList = [];

   // inbox-mapping inbox sorting
   ascending = true;
   // inbox-mapping left employee Data
   storeEmployeeData = [];
   storeConcatIdCode = [];
   storeCheckedData = [];
   storeCheckedDataQueue = [];
   allInboxes = [];
   isDeallocate = false;
   isMasterSel = false;
   addFieldSetting = {
    idField: 'Client_Id',
    textField: 'Client_Name'
  }
  constructor(
    // private clientService: ClientService,
    private selectedFields: dropDownFields,
    private router: Router,
    private notification: NotificationService,
    private fb: FormBuilder,
    private concluderInboxService: ConcluderInboxMappingService
  ) {
    this.token = new Token(this.router);
    this.userData = this.token.GetUserData();
    this.ResponseHelper = new ResponseHelper(this.notification);
  }
  ngOnInit() {
    this.getClientList();
    this.initForm();
    // this.getUserList();
  }

  initForm() {
    this.productivityForm = this.fb.group({
      processName: ['', Validators.required],
      reportType: ['', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      selectedMonth: [null, Validators.required]
    });
  }

  getClientList() {
    var token = new Token(this.router);
    var userdata = token.GetUserData();
    this.clientList = this.selectedFields.setSelected(userdata.Clients);
    if (this.clientList && this.clientList.length == 1) {
      this.ClientId = this.clientList[0].Client_Id;
      this.getUserList();
    }
  }

  getUserList() {
    console.log('getUserList() : ', this.ClientId);
    this.userList = [];
    this.concluderInboxService.getConcluderUserListByCLientID(this.ClientId).subscribe((response) => {
      console.log('getUserList() : ', response);
      if (response && response.Data && response.Data.EmployeeInfo) {
        this.userList = response.Data.EmployeeInfo ? response.Data.EmployeeInfo : [];
      }
      else {
        this.userList = []
      }
      // this.ResponseHelper.GetSuccessResponse(response);
    }, (error) => {
      this.userList = [];
      this.ResponseHelper.GetFaliureResponse(error);
      console.log('getUserList() error : ', error);
    })
    this.getCategoryList();
  }

  getCategoryList() {
    this.concluderInboxService.getConcluderCategoryListByCLientID(this.ClientId).subscribe((response) => {
      console.log('getConcluderCategoryListByCLientID response : ', response);
      if (response && response.Data && response.Data.Category_Info) {
        const { Category_Info } = response.Data;
        this.setCategoryList(Category_Info);
        // this.ResponseHelper.GetSuccessResponse(response);
      }
      else {
        this.treeData = [];
        this.notification.ChangeNotification([{ Message: "Category Not Found", Type: "ERROR" }]);
      }
    }, (error) => {
      this.treeData = [];
      this.ResponseHelper.GetFaliureResponse(error);
      console.log('getConcluderCategoryListByCLientID error : ', error);
    })
  }

  setCategoryList(list) {
    list.forEach(element => {
      element['isExpanded'] = false;
      element['backupList'] = [];
      element['queueList'] = [];

      // remove category all inbox from storeCheckedData array
      _.remove(this.storeCheckedData, function (value) {
        return value.Category === element.Name;
      });
      console.log(this.storeCheckedData, 'after search');
    });
    this.treeData = list;

  }

  toggleNodes(nodeObj, key) {
    this.ascending = true;
    // console.log('nodeObj, role : ', nodeObj, nodeObj[key], JSON.stringify(this.treeData));
    // const list = nodeObj[key];
    nodeObj.isExpanded = (nodeObj.isExpanded != undefined && nodeObj.isExpanded == true) ? false : true;
    // if (list && list.length > 0) {
    //   // alert('No '+role.toUpperCase()+' to show');
    //   return false;
    // }
    nodeObj.httpStatus = true;
    switch (key) {
      case 'queue': {
        // nodeObj.backupList = nodeObj.queueList != null && nodeObj.queueList.length > 0 ? JSON.parse(JSON.stringify(nodeObj.queueList)) : [];
        nodeObj.queueList = [];
        this.getQueues(nodeObj);

        // remove category all inbox from storeCheckedData array
        _.remove(this.storeCheckedData, function (value) {
          return value.Category === nodeObj.Name;
        });
        break;
      }
      case 'inbox': {
        // nodeObj.backupList = nodeObj.inboxList != null && nodeObj.inboxList.length > 0 ? JSON.parse(JSON.stringify(nodeObj.inboxList)) : [];
        nodeObj.inboxList = [];
        this.getInboxes(nodeObj)
        break;
      }
      default:
        break;
    }
  }



  getQueues(nodeObj) {
    nodeObj.httpStatus = true;
    console.log('getQueues : ', nodeObj);
    // setTimeout(() => {
    //   this.setQueues(nodeObj, nodeObj.backupList)
    // }, 1000);
    this.concluderInboxService.getQueueList(this.ClientId, nodeObj.Name).subscribe((response) => {
      console.log('getQueueList response : ', response);
      if (response && response.Data && response.Data.Queue_Info) {
        this.setQueues(nodeObj, response.Data.Queue_Info);
      }
      else {
        this.setQueues(nodeObj, []);
      }
    }, (error) => {
      console.log('getQueueList error : ', error);
      this.setQueues(nodeObj, [])
    })
    // this.clientService.getManagerProductivityReport(this.userData.TokenValue, this.productivityForm.value['processName'], 1, this.startDate, this.endDate).subscribe((response) => {
    //   console.log('response : ', response);
    //   this.setQueues(nodeObj, response.Data.manager_InventoryList_count);
    // }, (error) => {
    //   console.log('error : ', error);
    //   nodeObj.httpStatus = false;
    //   nodeObj.refreshStatus = false;
    //   this.ResponseHelper.GetFaliureResponse(error);
    //   nodeObj.manager = [];
    // });
  }

  setQueues(nodeObj, queueList) {
    console.log('setQueues : ', nodeObj, queueList);
    if (queueList && queueList.length > 0) {
      queueList.forEach((element: any) => {
        element.inboxList = [];
      });
    }

    nodeObj.queueList = queueList != null && queueList.length > 0 ? queueList : [];
    nodeObj.httpStatus = false;
    nodeObj.refreshStatus = false;
  }

  getInboxes(nodeObj) {
    console.log('getInboxes nodeObj : ', nodeObj);
    nodeObj.httpStatus = true;
    // nodeObj.backupList = JSON.parse(JSON.stringify(nodeObj.inboxList));
    // nodeObj.inboxList = [];
    this.concluderInboxService.getInboxList(this.ClientId, nodeObj.Name).
      subscribe((response) => {
        console.log('response : ', response);
        if (response && response.Data && response.Data.Inbox_Info) {
          this.setInboxes(nodeObj, response.Data.Inbox_Info);
          nodeObj.status = nodeObj.status == true ? false : false;
        }
        else {
          this.setInboxes(nodeObj, []);
        }
      }, (error) => {
        this.setInboxes(nodeObj, []);
        console.log('error : ', error);
      })
    // const { startDate, endDate } = this.productivityForm.value;
    // this.clientService.getSupervisorProductivityReport(this.userData.TokenValue, this.productivityForm.value['processName'], nodeObj.EmployeeID, 1, this.startDate, this.endDate).subscribe((response) => {
    //   console.log('response : ', response)
    //   this.setInboxes(nodeObj, response.Data.manager_InventoryList_count);
    // }, (error) => {
    //   console.log('error : ', error);
    //   nodeObj.httpStatus = false;
    //   nodeObj.supervisor = [];
    //   this.ResponseHelper.GetFaliureResponse(error);
    // })
  }

  setInboxes(nodeObj, inboxList) {
    console.log('setInboxes : ', nodeObj, inboxList);
    if (inboxList && inboxList.length > 0) {
      nodeObj.inboxList = inboxList && inboxList.length > 0 ? inboxList : [];
      nodeObj.backupList = inboxList && inboxList.length > 0 ? inboxList : [];
    }
    else {
      nodeObj.inboxList = [];
      nodeObj.backupList = [];
    }
    inboxList.isSort = false;
    nodeObj.httpStatus = false;
  }
  matchInbox(queue) {
    // console.log('matchInbox : ', queue);
    queue.inboxList.forEach((element) => {
      var result = element.Name.toUpperCase().indexOf(queue.inboxName.toUpperCase());
      if (result !== -1) {
        element.show = true;
      }
      else {
        element.show = false;
      }
      // console.log('result : ', result, queue.inboxName, element.inbox)
    })
  }

   //Sorting Inbox Data
   sortInboxData(inboxList){
    const ascOrDesc = !this.ascending ? 'asc' : 'desc';
    inboxList.isSort = (inboxList.isSort != undefined && inboxList.isSort == true) ? false : true;
    inboxList.sort(this.dynamicsort("Count",ascOrDesc))
    // console.log(inboxList.sort(this.dynamicsort("Count",ascOrDesc)));
  }
  dynamicsort(property,order) {
    var sort_order = 1;
    if(order === "desc"){
        sort_order = -1;
    }
    return function (a, b){
        // a should come before b in the sorted order
        if(a[property] < b[property]){
                return -1 * sort_order;
        // a should come after b in the sorted order
        }else if(a[property] > b[property]){
                return 1 * sort_order;
        // a and b are the same
        }else{
                return 0 * sort_order;
        }
    }
}
// get selected Employee and store the employee Data
getEmployee(event){
  console.log(event, 'get employee');
    this.userList.filter((e, index)=> {
      // console.log(isArray(event));
      const eventData = Array.isArray(event) ? event[index] : event;
      // console.log(eventData);
      if(e.Employee_Id == eventData.Employee_Id){
        // console.log(this.storeEmployeeData[index]);
        const concatIdCode = e.Employee_Id.toString().concat('-',e.Employee_Code);
        this.storeConcatIdCode.push(concatIdCode);
        this.storeEmployeeData.push(e);
      }
    })
    // console.log(this.storeConcatIdCode);
    // console.log(this.storeEmployeeData, 'get selected employee');
  }
// get De-Selectedd Employee and remove the employee Data
  removeEmployee(event){
  console.log(event, "get remove employee");
  if (event.length == 0) {
    this.storeConcatIdCode = [];
    this.storeEmployeeData = [];
    return false;
  }
  for (var i = 0; i < this.storeEmployeeData.length; i++) {
    const eventData = Array.isArray(event) ? event[i] : event;
    if (this.storeEmployeeData[i].Employee_Id === eventData.Employee_Id) {
      this.storeEmployeeData.splice(i, 1);
      if (this.storeConcatIdCode[i].includes(event.Employee_Id)) {
        this.storeConcatIdCode.splice(i, 1);
      }
    }
  }
    console.log(this.storeConcatIdCode);
    console.log(this.storeEmployeeData, 'get employee');
  }
  //checked checkbox of queue and store the queue data
  onCheckboxChangeQueue(event, category, queue){
    // console.log(queue, 'queue');
    this.concluderInboxService.getInboxList(this.ClientId, queue.Name).
      subscribe((response) => {
        // console.log(response, 'response');
        const Data = response.Data.Inbox_Info;
        for (let i = 0; i < Data.length; i++) {
        this.onCheckboxChange(event,category,queue,Data[i].Name)
        // console.log(Data[i], 'allInboxes');
        }
        // this.setCheckedDataQueue(category,queue,this.allInboxes)
      });
  }
  checkUncheckAll(event, nodeObj, category,key){
    this.ascending = true;
    this.concluderInboxService
      .getInboxList(this.ClientId, nodeObj.Name)
      .subscribe((response) => {
        this.setInboxes(nodeObj, response.Data.Inbox_Info)
        // console.log(response, 'response');
        const Data = response.Data.Inbox_Info;
        for (let i = 0; i < Data.length; i++) {
          nodeObj.inboxList[i].isSelected = nodeObj.status == true ? true : false;
          // this.onCheckboxChange(event, category, queue, Data[i].Name);
          // console.log(nodeObj, 'allInboxes');
        }
        this.onCheckboxChangeQueue(event, category, nodeObj)
        // this.isMasterSel = !this.isMasterSel;
        // this.setCheckedDataQueue(category,queue,this.allInboxes)
      });
  }
  isAllSelected(event, nodeObj, category, inbox) {
    // console.log(nodeObj,inbox);
    this.isMasterSel = nodeObj.inboxList.every(function(item:any) {
      nodeObj.status = false;
        return item.isSelected == true;
      })
      // console.log(this.isMasterSel);
      if(this.isMasterSel) nodeObj.status = true;
    this.onCheckboxChange(event, category, nodeObj, inbox.Name)
  }
  //checked checkbox of queue and store the queue data / inbox data
  onCheckboxChange(event, category, queue, inbox){
    // console.log(event, category, queue, inbox, 'event inbox Data');
    if(event.target.checked == undefined) event.target.checked = false;
    if (event.target.checked) {
      this.setCheckedData(category, queue, inbox);
      // console.log(this.mergeArrayObjects(this.storeCheckedData));
    } else {
      // console.log(category, queue,queueName, inbox, 'unchecked');
      for (let i = 0; i < this.storeCheckedData.length; i++) {
        if(this.storeCheckedData[i].Category == category.Name &&
          this.storeCheckedData[i].Queue == queue.Name) {
            this.storeCheckedData[i].Inbox.find(e => {
              if(e == inbox) {
                this.storeCheckedData.splice(i,1);
              }
               console.log(this.storeCheckedData, 'inbox data unchecked');
            });
        }
      }
    }
  }
  //merge same category and queue name
  mergeArrayObjects(array){
    let arr2 = [];
    array.forEach((element) => { // remove duplicate Category
      let match = arr2.find((r) => r.Category == element.Category && r.Queue == element.Queue);
      if (match) {
      } else {
        arr2.push({ Category: element.Category,Queue: element.Queue, Inbox: [] });
      }
    });
    arr2.map((item) => {
      array.map((e) => {
        if (e.Category == item.Category && e.Queue == item.Queue) {
          if (typeof e.Inbox == "object") { //lets map if Inbox is an object
            e.Inbox.map((z) => {
              item.Inbox.push(z);
            });
          } else {
            item.Inbox.push(e.Inbox);
          }
        }
      });
    });
    // console.log(arr2, 'final map data');
    arr2.forEach(element => {
      var uniqueNames = this.getUnique(element.Inbox);
      element.Inbox = [];
      element.Inbox = uniqueNames;
    });
    console.log(arr2, 'final map data');
    return arr2;
  }
  // Defining function to get unique values from an array
 getUnique(array){
  var uniqueArray = [];
  // Loop through array values
  for(var value of array){
      if(uniqueArray.indexOf(value) === -1){
          uniqueArray.push(value);
      }
  }
  return uniqueArray;
}
  setCheckedData(category, queue, inbox){
    var obj = new Object();
    obj['Category'] = category.Name;
    obj['Queue'] = queue.Name;
    obj['Inbox'] = [inbox];
    console.log(obj);
    this.storeCheckedData.push(obj);
  }
  mapEmployeeCategory(){
    const inboxData = this.mergeArrayObjects(this.storeCheckedData);
    // console.log(this.ClientId, 'this.ClientId');
    // console.log(inboxData, 'inboxData deallocate');
    // console.log(this.storeConcatIdCode, 'storeConcatIdCode deallocate');
    const obj = new Object()
    obj['Client_Id'] = this.ClientId
    obj['Employee'] = this.getUnique(this.storeConcatIdCode);
    obj['Map'] = inboxData;
    console.log(obj);
    this.postMapAggents(obj);
  }
  postMapAggents(data){
    this.concluderInboxService.postMapAggents(data).subscribe((response)=>{
      // console.log(response, 'response');
      if(response) {
        this.ResponseHelper.GetSuccessResponse(response);
      }
    }, (error)=>{
      // console.log(error);
      this.ResponseHelper.GetFaliureResponse(error);
    })
  }
  deallocateEmployeeCategory(){
    this.isDeallocate = false;
    const inboxData = this.mergeArrayObjects(this.storeCheckedData);
    var emp_Code = [];
    // console.log(this.ClientId, 'this.ClientId');
    // console.log(inboxData, 'inboxData deallocate');
    for (let i = 0; i < this.storeConcatIdCode.length; i++) {
      emp_Code.push(parseInt(this.storeConcatIdCode[i].split('-')[1]));
    }
    // console.log(this.storeConcatIdCode,emp_Code, 'storeConcatIdCode deallocate');
    const obj = new Object();
    obj['Client_Id'] = this.ClientId
    obj['Employee_Code'] = this.getUnique(emp_Code);
    obj['Deallocate'] = inboxData;
    console.log(obj);
    this.postDeallocateAggents(obj);
  }
  postDeallocateAggents(data){
    this.concluderInboxService.postDeallocateAggents(data).subscribe((response)=>{
      // console.log(response, 'response');
      if(response) {
        this.ResponseHelper.GetSuccessResponse(response);
        this.getCategoryList();
      }
    }, (error)=>{
      // console.log(error);
      this.ResponseHelper.GetFaliureResponse(error);
    })
  }
  ClientListOnChange(event){
    this.ClientId = event.Client_Id
  }
}
